module.exports = __webpack_public_path__ + "img/Gaz_de_Bordeaux_120X35.6bca9238.png";